import React from "react";

const Heading = ({
  id,
  children,
  className = "",
}: {
  id?: string;
  className?: string;
  children: React.ReactNode;
}): React.ReactElement => (
  <h1
    id={id}
    className={`font-ttm text-[1.75rem] leading-[1.2] sm:text-[2.25rem] sm:leading-[40px] ${className}`}
  >
    {children}
  </h1>
);

export default React.memo(Heading);
